import { language as lan_privacyPolicy } from "./privacy-policy";
import { language as lan_addressViewer } from "./address-viewer";
import { language as lan_selectAddress } from "./select-address";
import { language as lan_addAddressForm } from "./add-address-form";
import { language as lan_priceList } from "./price-list";
import {language as lan_purchaseQuantity} from "./purchase-quantity/index";
import {language as lan_registPartnerVerify} from "./regist-partner-verify";
import { language as lan_qpLazyImage } from "./qp-lazy-image";

let language = {
    ...lan_privacyPolicy,
    ...lan_addressViewer,
    ...lan_selectAddress,
    ...lan_addAddressForm,
    ...lan_priceList,
    ...lan_purchaseQuantity,
    ...lan_registPartnerVerify,
    ...lan_qpLazyImage
};

export { language }